module.exports = __webpack_public_path__ + "img/icon-new-harlf-right.760e5e95.svg";